module.exports = __webpack_public_path__ + "static/media/picto-heart.50f0feff.svg";